export enum SubscriptionType {
  TYPE_ONE_TIME = 'one_type',
  TYPE_RECURRING = 'recurring',
  TYPE_GROUPED = 'grouped',
}
